import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { Text } from "@ui/Atoms/Text";

import type { TableProps } from "./Table.types";
import * as Styled from "./Table.styled";

export const Table: React.FC<TableProps> = props => {
  return (
    <TestWrapper testId={props.testId}>
      <Styled.Table>
        <Styled.THead>
          <tr>
            {props.headerLabels.map((label, index) => (
              <Text key={index} as="th" $style="bold_14">
                {label}
              </Text>
            ))}
            <th></th>
          </tr>
        </Styled.THead>

        {props.children}
      </Styled.Table>
    </TestWrapper>
  );
};
